import localization from "../../../config/localization";

export type ResetPasswordType = {
    type: string;
    title: string;
    description: string;

};

export const RESET_PASSWORD_TYPES: ReadonlyArray<ResetPasswordType> = ([
    {
        type: "OneClick",
        title: localization.welcome,
        description: localization.onclick_reset_password_label,
    },
    {
        type: "Whatsapp",
        title: localization.welcome,
        description: localization.whatsapp_reset_password_label,

    },
    {
        type: "Forgot",
        title: localization.forgot_password_link,
        description: localization.forgot_password_label,
    },
]);

export const RESET_PASSWORD_TYPE_ONE_CLICK = "OneClick";
export const RESET_PASSWORD_TYPE_WHATSAPP = "Whatsapp";
export const RESET_PASSWORD_TYPE_FORGOT = "Forgot";
